import React from 'react';
import type { SVGProps } from 'react';

const IconMail = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 29.892 20.453"
      {...props}
    >
      <path d="M27.892 0H0v20.453h29.892V0h-2Zm-2.243 2L14.946 8.178 4.244 2h21.405ZM2 18.453V3.014l12.945 7.472 12.946-7.472v15.438H2Z" />
    </svg>
  );
};

export default IconMail;
